import React from 'react';
import { isEmptyField } from '../utils';
import { run } from '@wix/forms-rules/v2';
class FormBase extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.inputRefs = {};
        this.fieldRefs = {};
        this.state = {
            errors: {},
            submissionStatus: {
                submitted: false,
                submitting: false,
                errorCode: undefined,
            },
            hidden: {},
            required: {},
            disabled: {},
            readonly: {},
            submission: ((_a = props.schema.fields) === null || _a === void 0 ? void 0 : _a.reduce((acc, f) => {
                var _a, _b;
                acc[f.externalId] =
                    (_b = (_a = f.renderInfo) === null || _a === void 0 ? void 0 : _a.displayProperties) === null || _b === void 0 ? void 0 : _b.defaultValue;
                return acc;
            }, {})) || {},
        };
    }
    submit() {
        const submissionState = this.validate();
        return {
            state: submissionState,
            submission: this.state.submission,
        };
    }
    isVisible(externalId) {
        return !this.state.hidden[externalId];
    }
    isRequired(externalId, renderInfo) {
        var _a;
        return this.state.required[externalId] !== undefined
            ? this.state.required[externalId]
            : (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _a === void 0 ? void 0 : _a.required;
    }
    isDisabled(externalId, renderInfo) {
        var _a;
        return this.state.disabled[externalId] !== undefined
            ? this.state.disabled[externalId]
            : (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.disabled;
    }
    isReadonly(externalId, renderInfo) {
        var _a;
        return this.state.readonly[externalId] !== undefined
            ? this.state.readonly[externalId]
            : (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.readOnly;
    }
    validate() {
        var _a;
        let focused = false;
        const { schema } = this.props;
        const currentErrors = ((_a = schema.fields) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
            const externalId = curr.externalId;
            const invalidMessage = this.validateField({
                externalId,
                renderInfo: curr.renderInfo,
                updatedValue: this.state.submission[externalId],
            });
            if (invalidMessage) {
                acc[externalId] = invalidMessage;
                if (!focused) {
                    let refId = externalId;
                    if (invalidMessage instanceof Object) {
                        const keys = Object.keys(invalidMessage);
                        if (keys.length > 0) {
                            refId = `${externalId}-${keys[0]}`;
                        }
                    }
                    const input = this.inputRefs[refId];
                    if (input && input.focus) {
                        input.focus();
                        focused = true;
                    }
                    else {
                        const fieldRef = this.fieldRefs[externalId];
                        if (fieldRef && fieldRef.scrollIntoView) {
                            fieldRef.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                            focused = true;
                        }
                    }
                }
            }
            return acc;
        }, {})) || {};
        this.setState({ errors: currentErrors });
        return {
            valid: Object.keys(currentErrors).length === 0,
            errors: currentErrors,
        };
    }
    validateComplexAddress(externalId, renderInfo, updatedValue) {
        var _a;
        const multiLineAddressOptions = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.multiLineAddressSettings;
        if (!multiLineAddressOptions) {
            return undefined;
        }
        const invalidMessage = {};
        Object.keys(multiLineAddressOptions).forEach((key) => {
            const addressKey = key;
            const addressPartRenderInfo = multiLineAddressOptions[addressKey];
            if (addressPartRenderInfo) {
                const invalid = this.validateField({
                    externalId,
                    renderInfo: addressPartRenderInfo,
                    internalId: key,
                    updatedValue: updatedValue && updatedValue[addressKey],
                });
                if (invalid) {
                    invalidMessage[addressKey] = invalid;
                }
            }
        });
        if (Object.keys(invalidMessage).length > 0) {
            return Object.keys(invalidMessage).reduce((acc, key) => {
                const addressKey = key;
                const value = invalidMessage[addressKey];
                if (value) {
                    acc[key] = value;
                }
                return acc;
            }, {});
        }
        return undefined;
    }
    validateNumberField(externalId, renderInfo) {
        var _a, _b;
        const { translateMessage } = this.props;
        const actualInput = this.inputRefs[externalId];
        actualInput === null || actualInput === void 0 ? void 0 : actualInput.checkValidity();
        const validationProperties = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties;
        if (typeof (validationProperties === null || validationProperties === void 0 ? void 0 : validationProperties.max) === 'number' ||
            typeof (validationProperties === null || validationProperties === void 0 ? void 0 : validationProperties.min) === 'number') {
            if (((_a = actualInput === null || actualInput === void 0 ? void 0 : actualInput.validity) === null || _a === void 0 ? void 0 : _a.rangeOverflow) ||
                ((_b = actualInput === null || actualInput === void 0 ? void 0 : actualInput.validity) === null || _b === void 0 ? void 0 : _b.rangeUnderflow)) {
                return translateMessage({
                    type: 'VALUE_OUT_OF_RANGE',
                    context: { externalId, renderInfo },
                });
            }
        }
        return undefined;
    }
    validateField({ externalId, renderInfo, updatedValue, internalId, }) {
        var _a, _b, _c;
        if (this.isDisabled(externalId, renderInfo) ||
            this.isReadonly(externalId, renderInfo)) {
            return;
        }
        const { translateMessage } = this.props;
        if (this.isRequired(externalId, renderInfo)) {
            if (isEmptyField(renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.type, updatedValue)) {
                return translateMessage({
                    type: 'VALUE_REQUIRED',
                    context: { externalId, renderInfo, internalId },
                });
            }
        }
        const value = updatedValue;
        if (value) {
            const pattern = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.validationProperties) === null || _a === void 0 ? void 0 : _a.pattern;
            if (pattern) {
                const actualInput = this.inputRefs[externalId];
                actualInput === null || actualInput === void 0 ? void 0 : actualInput.checkValidity();
                const isInvalidPattern = ((_b = actualInput === null || actualInput === void 0 ? void 0 : actualInput.validity) === null || _b === void 0 ? void 0 : _b.patternMismatch) ||
                    ((_c = actualInput === null || actualInput === void 0 ? void 0 : actualInput.validity) === null || _c === void 0 ? void 0 : _c.typeMismatch);
                if (isInvalidPattern) {
                    return translateMessage({
                        type: 'INVALID_PATTERN',
                        context: { externalId, renderInfo },
                    });
                }
            }
        }
        let customReturnValue;
        switch (renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.type) {
            case 'NUMBER':
                customReturnValue = this.validateNumberField(externalId, renderInfo);
                break;
            case 'MULTI_LINE_ADDRESS':
                customReturnValue = this.validateComplexAddress(externalId, renderInfo, updatedValue);
                break;
        }
        if (!customReturnValue) {
            const { onValidateField } = this.props;
            if (onValidateField) {
                const isValid = onValidateField({
                    externalId,
                    renderInfo,
                    updatedValue,
                    internalId,
                });
                if (isValid !== true) {
                    customReturnValue = translateMessage({
                        type: isValid,
                        context: { externalId, renderInfo, internalId },
                    });
                }
            }
        }
        return customReturnValue;
    }
    setFieldDisplayProperties(fieldDisplayProperties = {}) {
        var _a;
        const disabled = {};
        const readonly = {};
        const fieldValues = {};
        Object.keys(fieldDisplayProperties).forEach((externalId) => {
            const displayProperties = fieldDisplayProperties[externalId];
            if (displayProperties.hasOwnProperty('disabled')) {
                disabled[externalId] = !!displayProperties.disabled;
            }
            if (displayProperties.hasOwnProperty('readonly')) {
                readonly[externalId] = !!displayProperties.readonly;
            }
            if (displayProperties.hasOwnProperty('value')) {
                fieldValues[externalId] = displayProperties.value;
            }
        });
        const { hidden, required } = run(((_a = this.props.schema.formViewInfo) === null || _a === void 0 ? void 0 : _a.rule) || [], fieldValues);
        this.setState((prev) => ({
            hidden,
            required,
            disabled: Object.assign(Object.assign({}, prev.disabled), disabled),
            readonly: Object.assign(Object.assign({}, prev.readonly), readonly),
            submission: Object.assign(Object.assign({}, prev.submission), fieldValues),
        }));
    }
    onFieldChange(field, value) {
        const { onChange } = this.props;
        if (onChange) {
            onChange(field.externalId, value);
        }
        this.setFieldDisplayProperties({ [field.externalId]: { value } });
    }
    onFieldBlur(field, updatedValue) {
        const externalId = field.externalId;
        if (this.state.errors[externalId]) {
            const invalidMessage = this.validateField({
                externalId,
                renderInfo: field.renderInfo,
                updatedValue,
            });
            this.setState((prev) => ({
                errors: Object.assign(Object.assign({}, prev.errors), { [field.externalId]: invalidMessage }),
            }));
        }
    }
}
export default FormBase;
//# sourceMappingURL=FormBase.js.map